import { render, staticRenderFns } from "./comfir.vue?vue&type=template&id=6196fcb2&scoped=true&"
import script from "./comfir.vue?vue&type=script&lang=js&"
export * from "./comfir.vue?vue&type=script&lang=js&"
import style0 from "./comfir.vue?vue&type=style&index=0&id=6196fcb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6196fcb2",
  null
  
)

export default component.exports